// A library selection chooses a reading unit before loading the reader.
export function libraryContentsEntries(toc) {
  const entries = [];
  const seen = new Set();
  let headers = [];
  for (const row of toc?.sections || []) {
    if (row.isHeader) {
      headers = headers.slice(0, row.depth || 0);
      headers.push(row);
      continue;
    }
    const ref = row.readerRef || row.ref || row.targetRef;
    if (!ref) continue;
    const discourse = String(row.ref || ref).match(/^(.*?\b(?:Sicha|Maamar)\s+\d+)(?=,|\s+(?:Section|Seif)|$)/i)?.[1];
    const key = discourse || ref;
    if (seen.has(key)) continue;
    seen.add(key);
    const header = headers[headers.length - 1];
    const label = discourse ? header?.label || discourse.split(',').slice(-1)[0].trim() : row.label || ref;
    entries.push({ ...row, ref, label,
      heLabel: discourse ? header?.heLabel || row.heLabel : row.heLabel,
      group: headers.map(item => item.label).filter(Boolean).join(' · '),
    });
  }
  return entries;
}
